module.exports = __webpack_public_path__ + "img/NewFoundPioneerCorpsArma3UnitLogo.9cc12d65.webp";